import {makeStyles, Typography} from "@material-ui/core";
import time, {Duration, TimeUnit} from "../../core/time";
import {useEffect, useRef, useState} from "react";
import UserEvent from "../../core/UserEvent";
import PropTypes from "prop-types";
import clsx from "clsx";
import numeral from '../../core/numeral';
import logger from "../../core/logger";
import usePrevious from "../../hook/usePrevious";
import useInterval from "../../hook/useInterval";

const CLASSNAME = 'appfuse-timer';

const log = logger.getLogger("appfuse/Timer");

const useStyles = makeStyles(theme => ({
    root: {
        display: props => props.display,
    }
}));

function Timer(props) {
    const {className, style, variant, color} = props;
    const {duration, countdown} = props;

    // 剩餘秒數
    const [counter, setCounter] = useState(0);
    const startTimeRef = useRef(new Date());
    const timeoutRef = useRef(false);

    useEffect(() => {
        const current = ((duration instanceof Duration) ? duration : Duration.of(duration, TimeUnit.SECOND));
        const now = new Date();
        const counter = Math.max(0, Math.ceil(current.toSeconds()));
        startTimeRef.current = now;
        timeoutRef.current = false;
        setCounter(counter);
    }, [duration]);

    useInterval(() => {
        const timeout = timeoutRef.current;
        if(timeout) return;

        const startTime = startTimeRef.current;
        const now = new Date();

        const durationInSeconds = (duration instanceof Duration) ? duration.toSeconds() : duration;
        const countdownInSeconds = (countdown instanceof Duration) ? countdown.toSeconds() : countdown;
        const counter = durationInSeconds - Math.floor(time.between(startTime, now).toSeconds());
        setCounter(counter);
        props.onTick && props.onTick(new UserEvent({value: counter, duration, countdown}));
        if(counter <= 0) {
            timeoutRef.current = true;
            props.onTimeout && props.onTimeout(new UserEvent({value: counter, duration, countdown}));
        } else {
            if(countdown && counter <= countdownInSeconds) {
                props.onCountdown && props.onCountdown(new UserEvent({value: counter, duration, countdown}));
            }
        }

    }, 1000);

    // 顯示剩餘時間
    const timeout = Duration.of(counter, TimeUnit.SECOND);
    const seconds = timeout.seconds();
    const minutes = timeout.minutes();
    const hours = timeout.hours();
    const countdownInSeconds = (countdown instanceof Duration) ? countdown.toSeconds() : countdown;

    let text = numeral.format(seconds, '00');
    minutes && (text = numeral.format(minutes, '00') + ':' + text);
    hours && (text = numeral.format(hours, '00') + ':' + text);

    const display = (countdown && counter > countdownInSeconds) ? 'none' : '';

    const classes = useStyles({display});

    return (
        <Typography className={clsx(CLASSNAME, classes.root, className)} style={{display: display, ...style}}
                    variant={variant} color={color} noWrap={true}>
            {text}
        </Typography>
    );
}

Timer.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    duration: PropTypes.oneOfType([
        PropTypes.instanceOf(Duration),
        PropTypes.number // seconds
    ]),
    countdown: PropTypes.oneOfType([
        PropTypes.instanceOf(Duration),
        PropTypes.number // seconds
    ]),
    onTimeout: PropTypes.func,
    onCountdown: PropTypes.func,
    onTick: PropTypes.func,
    variant: PropTypes.oneOf([
        'body1', 'body2', 'button', 'caption',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'inherit', 'overline', 'subtitle1', 'subtitle2', 'string'
    ]),
    color: PropTypes.oneOf([
        "initial", "inherit", "primary", "secondary", "textPrimary", "textSecondary", "error"
    ])
}

Timer.defaultProps = {
    variant: 'body1'
}

export default Timer;